import { Mappable } from '../../_shared/mappable.class';

export class PosOperator extends Mappable<PosOperator> {

    operatorId: number;
    vendorId: number;
    stationId: number;

    name: string;
    email: string;
    phoneNumber: string;
    username: string;
    guest: boolean;
    expires: Date;
    dateCreated: Date;

    guestPassword: string;
    verified: boolean;
    active: boolean;

    location: Location;
}